import React, { useEffect, useState } from "react";
import "./servicepage.css";
import { Helmet } from "react-helmet";
import { Accordion, Tab, Tabs } from "react-bootstrap";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Appointmentform from "../appointmentpage/appointmentform";
import GetApiCall from "../API/GETAPI";
import Corporatetraining from "../servicepage/serviceinner/corporatetraining";
import createDOMPurify from "dompurify";
import GetSeoData from "../API/GetSeoData";
import { useParams } from "react-router-dom";
import PostApiCall from "../API/POSTAPI";
import { Skeleton } from "antd";
import Simage from "../img/services/astrology-service-image_1.webp";

// Static banner imports (or use public paths)
import astrologyDesktop from "../img/inner-desktop-banners/blessings-inner-astrology-banner.webp";
import astrologyMobile from "../img/inner-mobile-banners/astrology-blessing-mobile.webp";

import vastushastraDesktop from "../img/inner-desktop-banners/blessings-inner-vastu-banner.webp";
import vastushastraMobile from "../img/inner-mobile-banners/vastu-blessing-mobile.webp";

import handwritingDesktop from "../img/inner-desktop-banners/blessings-inner-handwritting-banner.webp";
import handwritingMobile from "../img/inner-mobile-banners/handwritting-blessing-mobile.webp";

import tarotDesktop from "../img/inner-desktop-banners/blessings-inner-tarrot-banner.webp";
import tarotMobile from "../img/inner-mobile-banners/tarot-blessing-mobile.webp";

import palmistryDesktop from "../img/inner-desktop-banners/blessings-inner-palmistry-banner.webp";
import palmistryMobile from "../img/inner-mobile-banners/PALMISTRY-blessing-mobile.webp";

import numerologyDesktop from "../img/inner-desktop-banners/blessings-inner-NUMERLOGY-banner.webp";
import numerologyMobile from "../img/inner-mobile-banners/numerology-blessing-mobile.webp";

import reikihealingDesktop from "../img/inner-desktop-banners/blessings-inner-reiki-banner.webp";
import reikihealingMobile from "../img/inner-mobile-banners/REIKI-blessing-mobile.webp";

import pujaDesktop from "../img/inner-desktop-banners/blessings-inner-puja-banner.webp";
import pujaMobile from "../img/inner-mobile-banners/PUJA-blessing-mobile.webp";

import corporatetrainingDesktop from "../img/inner-desktop-banners/blessings-inner-corporate-banner.webp";
import corporatetrainingMobile from "../img/inner-mobile-banners/corporate-blessing-mobile.webp";

// Optional: default banner
import defaultDesktop from "../img/inner-desktop-banners/blessings-inner-our-services-banner.webp";
import defaultMobile from "../img/inner-mobile-banners/blessing-our-services-mobile.webp";
const categoryBanners = {
  astrology: {
    desktop: astrologyDesktop,
    mobile: astrologyMobile,
    heading: "Astrology Expert in Gurgaon",
    // subHeading: "in India",
  },
  vastushastra: {
    desktop: vastushastraDesktop,
    mobile: vastushastraMobile,
    heading: "Vastu Consultant in Gurgaon ",
    // subHeading: "in India",
  },
  handwritingandsignatureanalysis: {
    desktop: handwritingDesktop,
    mobile: handwritingMobile,
    heading: "Heading: Your Writing,  ",
    subHeading: "Your Identity",
  },
  tarot: {
    desktop: tarotDesktop,
    mobile: tarotMobile,
    heading: "Tarot Card Reader in Gurgaon",
    // subHeading: "in India",
  },
  palmistry: {
    desktop: palmistryDesktop,
    mobile: palmistryMobile,
    heading: "Palm Reader in Gurgaon   ",
    // subHeading: "in India",
  },
  numerology: {
    desktop: numerologyDesktop,
    mobile: numerologyMobile,
    heading: " Numerologer in Gurgaon    ",
    // subHeading: "in India",
  },
  reikihealing: {
    desktop: reikihealingDesktop,
    mobile: reikihealingMobile,
    heading: "Best Reiki Healer    ",
    subHeading: "in India",
  },
  puja: {
    desktop: pujaDesktop,
    mobile: pujaMobile,
    heading: " Personalized Puja for     ",
    subHeading: "peace and prosperit",
  },
  corporatetraining: {
    desktop: corporatetrainingDesktop,
    mobile: corporatetrainingMobile,
    heading: " Boost productivity with     ",
    subHeading: " mindful leadership",
  },
};

const normalizeCategory = (name) =>
  name?.toLowerCase().replace(/[^a-z0-9]/gi, "");
const DOMPurify = createDOMPurify(window);
export default function ServiceDetails() {
  const params = useParams();
  const [showForm, setShowForm] = useState(false);
  const [serviceTitle, setServiceTitle] = useState("");
  const [faqData, setFaqData] = useState([]);
  const [serviceDetail, setServiceDetail] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 568);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // GetFAQData();
  }, [params.servicename]);
  useEffect(() => {
    GetServiceData();
  }, [params.servicename]);

  const GetServiceData = () => {
    PostApiCall.postRequest(
      {
        catCount: "*",
        whereClause: `where fld_route = '${params.servicename}'`,
      },
      "Services"
    ).then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          const fetchedservice = obj1.data.filter(
            (data) => data.fld_status === "Active"
          );
          setServiceDetail(fetchedservice);
          setLoading(true);
          GetApiCall.getRequest("GetJsonFAQS").then((results) => {
            results.json().then((obj) => {
              if (results.status == 200 || results.status == 201) {
                let filteredJsonFaq = [];
                if (fetchedservice[0]?.fld_service_name === "Vastu Shastra") {
                  filteredJsonFaq = obj?.data?.filter(
                    (item) => item.service === "Vastu"
                  );
                }
                if (fetchedservice[0]?.fld_service_name === "Astrology") {
                  filteredJsonFaq = obj?.data?.filter(
                    (item) => item.service === "Astrology"
                  );
                }
                if (fetchedservice[0]?.fld_service_name === "Tarot") {
                  filteredJsonFaq = obj?.data?.filter(
                    (item) => item.service === "Tarot"
                  );
                }
                if (fetchedservice[0]?.fld_service_name === "Palmistry") {
                  filteredJsonFaq = obj?.data?.filter(
                    (item) => item.service === "Palmistry"
                  );
                }
                if (fetchedservice[0]?.fld_service_name === "Numerology") {
                  filteredJsonFaq = obj?.data?.filter(
                    (item) => item.service === "Numerology"
                  );
                }
                // const serviceFaq = activeServices.filter(
                //   (item) =>
                //     item.service ===
                //     fetchedservice[0]?.fld_service_name
                // );
                setFaqData(filteredJsonFaq);
              }
            });
          });
        }
      })
    );
  };

  const showModal = (details) => {
    setShowForm(true);
    setServiceTitle(details?.fld_service_name);
  };

  const closeModal = () => {
    setShowForm(false);
  };
  // const textContent = new DOMParser().parseFromString(serviceDetail[0]?.fld_long_desc, 'text/html').body.textContent;
  const categoryKey = normalizeCategory(serviceDetail[0]?.fld_service_name);
  const banner = categoryBanners[categoryKey] || {
    desktop: defaultDesktop,
    mobile: defaultMobile,
  };
  return (
    <>
      <GetSeoData type="service" id={null} route={params.servicename} />

      <section className="inner-section service-page">
        {/* <NavBar /> */}
        {/* <div className="page-title-area">
          <div className="container-fluid pe-4 h-100 d-flex justify-content-end align-items-center">
            <div className="page-title-content">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/services">Services</a>
                </li>
                {loading == true ? (
                  <li>{serviceDetail[0]?.fld_service_name}</li>
                ) : (
                  <Skeleton.Input />
                )}
              </ul>
            </div>
          </div>
        </div> */}
        <div className="position-relative about-banner">
          <img
            src={isMobile ? banner.mobile : banner.desktop}
            alt={`${serviceDetail[0]?.fld_categoryname} banner`}
            className="img-fluid w-100"
          />
          <h2>
            {banner?.heading} <br className="d-lg-none d-block" />
            {banner?.subHeading}
          </h2>
          {/* <h3>Expert Guidance, Trusted Solutions</h3> */}
        </div>
        <section className="spacing pb-2">
          <div className="container-fluid py-4">
            {loading === true ? (
              <>
                <div className="main-heading mb-0 col-12 mb-4 text-center">
                  {/* <p className="m-0">lorem lorem lorem lorem lorem</p> */}
                </div>
                <div className="row astrology-page-service p-lg-4">
                  <div className="col-lg-4">
                    <div className="astrology-image">
                      <img
                        src={serviceDetail[0]?.fld_image}
                        // src={Simage}
                        className="img-fluid w-100  "
                        alt={`${serviceDetail[0]?.fld_service_name} By Dr. Surabhi Bhatnagar | Blessings Astrology`}
                      />
                    </div>
                  </div>
                  <div className="col-lg-8 service-inner-card px-lg-3 d-lg-flex align-items-center">
                    <div className="astrology-content mt-lg-0 mt-3">
                      {/* <p>{textContent}</p> */}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: serviceDetail[0]?.fld_long_desc,
                        }}
                      />
                      <div className="read-more mt-4">
                        {/* <a onClick={() => showModal(serviceDetail[0])}>
                          {" "}
                          Book An Appointment
                        </a> */}
                        <a href="/book-an-appointment">Book an Appointment</a>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="main-heading mb-0 col-12 mb-4 text-center">
                  <Skeleton.Input />
                  {/* <p className="m-0">lorem lorem lorem lorem lorem</p> */}
                </div>
                <div className="row astrology-page-service p-lg-4 astro-skelton">
                  <div className="col-lg-4">
                    <div className="astrology-image">
                      <Skeleton.Image className="img-fluid w-100  " />
                    </div>
                  </div>
                  <div className="col-lg-8 service-inner-card px-lg-3">
                    <div className="astrology-content mt-lg-0 mt-3">
                      <Skeleton.Input />
                      <div className="read-more mt-4">
                        <Skeleton.Input className="w-100" />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {faqData.length > 0 && (
              <div className="row">
                <div className="main-heading faqs-heading text-center mb-0 col-12 ">
                  <h3 className=" my-3">FAQs</h3>
                  <h5>
                    Wondering About {serviceDetail[0]?.fld_service_name}? Find
                    Your Answers Here
                  </h5>
                </div>
                <div className="col-12 faq-main">
                  <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
                    <Tab
                      eventKey={1}
                      // title={serviceDetail[0]?.fld_service_name}
                    >
                      <Accordion defaultActiveKey="0">
                        {faqData.map((items, index) => (
                          <>
                            <Accordion.Item eventKey={index}>
                              <Accordion.Header>
                                {items.fld_question}
                              </Accordion.Header>
                              <Accordion.Body>
                                {items.fld_answer}
                              </Accordion.Body>
                            </Accordion.Item>
                          </>
                        ))}
                      </Accordion>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            )}
          </div>
        </section>
      </section>
      {serviceDetail[0]?.fld_service_name === "Corporate Training" && (
        <Corporatetraining />
      )}
      {showForm && (
        <Appointmentform
          serviceName={serviceDetail[0]?.fld_service_name}
          showForm={showForm}
          closeModal={closeModal}
        />
      )}
    </>
  );
}
